// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  env: 'dev',
  hideConsole: false,
  production: false,
  applications: {
    fortify: {
      v2: 'https://devv2.fortify.lcptracker.net',
      api: 'https://devv2.fortify.lcptracker.net/api',
    },
  },
  authentication: {
    issuer: 'https://devv2.fortify.lcptracker.net',
    redirectUrl: `${window.location.origin}/login/success`,
    postLogoutRedirectUri: 'https://dev.userportal.lcptracker.net/post-logout',
    clientId: 'ProjectsSpa',
    responseType: 'code',
    scope: 'openid profile offline_access email theidserveradminapi rbsApi MessagingService',
    silentRenewUrl: 'https://devv2.fortify.lcptracker.net/connect/token',
    renewTimeBeforeTokenExpiresValue: 300,
  },

  graphql: {
    gateway: {
      name: 'GatewayGraphQL',
      url: 'https://lcp-gateway-dev-appsvs.azurewebsites.net/graphql/',
    },
    project: {
      name: 'ProjectGraphQL',
      url: 'https://lcp-project-dev-appsvs.azurewebsites.net/graphql/',
    },
    rbs: {
      name: 'RBSGraphQL',
      url: 'https://lcp-rbs-dev-appsvs.azurewebsites.net/graphql/',
    },
    wageData: {
      name: 'WageGraphQL',
      url: 'https://lcp-wagedata-dev-appsvs.azurewebsites.net/graphql/',
    },
    email: {
      name: 'EmailMessagingGraphql',
      url: 'https://dev-msgsvs.lcptracker.net/graphql/',
    },
  },

  userPortalHost: 'https://dev.userportal.lcptracker.net',
  userPortalSso: 'https://dev.userportal.lcptracker.net/login/sso',
  smartClientURL: 'https://dev-apim.lcptracker.net/smartclientapi',
  lcpTrackerURL: 'https://dev.lcptracker.net',
  requiredMicroservices: [
    'f0a09ad5-9a23-4acc-a4bb-b2a6ff207f5d',
    '2df5920e-f28e-4ec8-b773-60165baf81e9',
  ],
  sendGrid: {
    template: 'ZC1kZDZmMmE1N2JlYTA0',
    key: 'MGUzOThiZGVjMGJiZTkxZTFkMw==',
  },
};

/*

 * For easier debugging in development mode, you can import the following file

 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.

 * This import should be commented out in production mode because it will have a negative impact

 * on performance if an error is thrown.

 */

// import 'zone.js/plugins/zone-error';
// Included with Angular CLI.Collapse
